export const parseNotificationItem = (item) => {
  if (!item) return null;

  const id = item.id ?? item.communication_template_log_id;
  if (id == null) return null;

  return {
    id,
    title: item.title || "",
    desc: item.desc || item.description || "",
    isSeen: Boolean(item.isSeen),
    ctaLabel: item.ctaLabel || item.cta_label || null,
    timestampLabel: item.timestampLabel || item.timestamp_label || null,
    actionUrl: item.actionUrl || item.action_url || item.redirect_url || null,
  };
};

export const parseNotificationsResponse = (response) => {
  const payload = response?.data ?? response;
  const list = Array.isArray(payload?.notifications)
    ? payload.notifications
    : [];

  const notifications = list.map(parseNotificationItem).filter(Boolean);

  const totalRaw =
    payload?.total ??
    payload?.totalCount ??
    payload?.total_count ??
    payload?.count;

  const total =
    totalRaw != null && !Number.isNaN(Number(totalRaw))
      ? Number(totalRaw)
      : notifications.length;

  return { notifications, total };
};
